export var BreadcrumbType;
(function (BreadcrumbType) {
    BreadcrumbType["DOM"] = "dom";
    BreadcrumbType["HTTP"] = "http";
})(BreadcrumbType || (BreadcrumbType = {}));
export var BreadcrumbCategory;
(function (BreadcrumbCategory) {
    BreadcrumbCategory["ROUTE"] = "route";
})(BreadcrumbCategory || (BreadcrumbCategory = {}));
//# sourceMappingURL=breadcrumb.js.map